import { Checkbox, FormControl, FormControlLabel, withStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import { observer } from 'mobx-react';
import * as React from 'react';
import { transl } from '../main/transl';
import { OcScreen } from '../pages/OcScreen';
import { settingsStore } from './SettingsStore';

@observer class _Settings extends OcScreen<{classes: any, store: any}> {
	renderBody() {
		const {classes, store} = this.props;
		return <FormControl className={classes.control}>
			<FormControlLabel
				label={transl('settings.dummy')}
				control={<Checkbox name={name} checked={store.dummy} color="default" onChange={store.onDummyChange}/>}
			/>
		</FormControl>;
	}
}

const styles = createStyles({
});

const __Settings = withStyles(styles)(_Settings);

export const Settings = (props: {}) => <__Settings {...props} store={settingsStore}/>;
